import Axios from 'axios-observable';
import { map, Observable } from 'rxjs';
import { BACK_URL } from '../../Utils/Constants';

export class Request {
  private static axiosInstance: Axios;

  private path: string = '';
  private headers: any = {};
  private body: any = {};
  private params: any = {};

  public constructor(private endpoint?: string) {}

  public static createInstanceWithToken(token: string): void {
    this.axiosInstance = Axios.create({
      baseURL: BACK_URL,
      headers: {
        Authorization: token
      }
    });
  }

  public withPath(path: string): Request {
    this.path = path;
    return this;
  }

  public withParams(params: any): Request {
    this.params = params;
    return this;
  }

  public withBody(body: any): Request {
    this.body = body;
    return this;
  }

  public withHeaders(headers: any): Request {
    this.headers = headers;
    return this;
  }

  public get<T>(): Observable<T> {
    return this.request('GET');
  }

  public post<T>(): Observable<T> {
    return this.request('POST');
  }

  public delete<T>(): Observable<T> {
    return this.request('DELETE');
  }

  private request<T>(method: 'GET' | 'POST' | 'DELETE'): Observable<T> {
    if (Request.axiosInstance) {
      return Request.axiosInstance
        .request({
          method: method,
          url: this.path,
          data: this.body,
          params: this.params
        })
        .pipe(map((res) => res.data));
    }
    return Axios.request({
      method: method,
      baseURL: this.endpoint,
      url: this.path,
      data: this.body,
      params: this.params,
      headers: this.headers
    }).pipe(map((res) => res.data));
  }
}
